<template>
    <div>
        <template v-if="control.singleMode">
            <!--
            <input type="text"
                   :id="control.uniqueId"
                   :name="control.name || control.uniqueId"
                   :placeholder="localizedPlaceholder"
                   :class="styles.FORM.FORM_CONTROL"
                   autocomplete="off"
            />
            -->

            <DatePicker
                :id="control.uniqueId"
                :name="control.name || control.uniqueId"
                :placeholder="localizedPlaceholder"
                :input-class="[styles.FORM.FORM_CONTROL, prefillClass]"
                v-model="currentValue"
                lang="en"
                :format="control.format"
                valueType="format"
                @change="handleDateChange"
                :disabled="isPrefillReadonly"
                append-to-body>
                <i class="glyphicon glyphicon-th" slot="calendar-icon" />
            </DatePicker>
        </template>
        <template v-else>
            <input type="text"
                   :id="control.uniqueId"
                   :placeholder="localizedPlaceholder"
                   :class="styles.FORM.FORM_CONTROL"
                   autocomplete="off"
            />

            <!--
            Why I need to implement this?
            Because in <form> mode, when submitting. The form need to send these together, therefore in the backend
            You will have some sort like: abc[startDate], abc[endDate] (Object/AssocArray)
            Its kinda useless for Ajax Mode :D
            -->
            <input type="hidden"
                   :name="startDateFieldName"
                   :value="hasStartDate ? value.startDate : ''"
            >
            <input type="hidden"
                   :name="endDateFieldName"
                   :value="hasEndDate ? value.endDate : ''"
            >
        </template>
    </div>
</template>

<script>
    import {CONTROL_FIELD_EXTEND_MIXIN} from "../../mixins/control-field-extend-mixin";
    import Litepicker from 'litepicker';
    import DatePicker from "vue2-datepicker";
    //import dayjs from 'dayjs';
    import moment from 'moment';
    import {DATE_PICKER_RETURN_TYPES} from "../../configs/control-config-enum";
    import formatDateForDisplay from "../../libraries/format-date-display";

    export default {
        name: "DatePickerControl",        
        components: { DatePicker },  
        mixins: [CONTROL_FIELD_EXTEND_MIXIN],
        data: () => ({
            datepicker: null,
            currentValue: null,            
        }),

        model: {
            event: 'change',
            prop: 'value'
        },

        watch: {
            control: {
                deep: true,
                handler(val) {
                    //console.log(`in datepicker watch control: ${val}`);
                    this.setOption(val);
                },
            },
            // `immediate` so a value already present at mount is applied — controls
            // inside conditionally-visible sections mount AFTER their data is loaded,
            // so their value never "changes" and a non-immediate watcher never fires
            // (that was the "Policy Holder's Birth Date not staying" bug, 2026-07-01).
            // The mixin has its own non-immediate `value` watcher; both call setValue
            // (idempotent), so change-driven updates keep working too.
            value: {
                immediate: true,
                handler(val) {
                    this.setValue(val);
                },
            },
        },

        methods: {
            /**
             * Re-set the DatePicker Configuration
             */
            setOption(ops = {}) {                
                if (!Object.keys(ops).length) {
                    return
                }

                if(this.datepicker)
                    this.datepicker.setOptions(ops)
            },

            /**
             * Special Func to set Value
             * @param val
             */
            setValue1(val) {
                //console.log(`in datepicker method setValue, value: ${val}`);
                if (val === null || val === undefined || val === '') {
                    this.datepicker.setDate(null)
                    return
                }

                // set for date-range
                if (typeof val === 'object' && val.startDate && val.endDate) {

                    // stop if same value
                    if (
                        this.currentValue &&
                        this.currentValue.startDate === val.startDate &&
                        this.currentValue.endDate === val.endDate
                    ) {
                        return
                    }

                    this.datepicker.setDateRange(val.startDate, val.endDate)
                    return
                }

                // set by single date
                if (typeof val === 'string' || val instanceof Date) {
                    // stop reset because of same date
                    if (this.val === this.currentValue) {
                        return
                    }

                    this.datepicker.setDate(val);
                }
            },

            setValue(d) {
                // Empty -> null (blank), formatted string -> passthrough, ISO/Date -> moment.
                // See libraries/format-date-display.js (unit-tested in node-tests).
                this.currentValue = formatDateForDisplay(d, this.control.format, this.control.returnType);
            },

            /**
             * Handle date change - blocks updates for prefilled today's date fields
             */
            handleDateChange(d) {
                // Block any date changes for prefilled today's date fields in renderer mode
                if (this.control.prefillTodayDate && !this.isBuilderMode) {
                    return;
                }
                this.getValue(d);
            },

            getValue(d) {
                if (d == null) {
                    return this.updateValue(null);
                }

                console.log('d', d);
                console.log('this.control', this.control);
                console.log('DATE_PICKER_RETURN_TYPES.format.val', DATE_PICKER_RETURN_TYPES.format.val);

                // ⚠️ (2026-07-27 date audit) emitValue is a MOMENT OBJECT, not a string — on submit,
                // JSON.stringify calls its .toJSON() and the wire carries a UTC ISO timestamp
                // (e.g. "1982-06-10T04:00:00.000Z" for a NY browser picking 06/10/1982). The backend
                // (forms-api saveOdData for 'Birthdate') formats it with moment(...) in Lambda-local
                // time, which is UTC — that lands on the CORRECT day only because every US timezone
                // is behind UTC. If Lambda TZ or non-US customers ever change that assumption, or if
                // you touch this line, emit moment(d, this.control.format).format('YYYY-MM-DD')
                // instead and verify the OD write + stored-submission display end-to-end.
                //let emitValue = moment(d).format('YYYY-MM-DD');
                let emitValue = moment(d, this.control.format);
                if (this.control.returnType === DATE_PICKER_RETURN_TYPES.format.val) {
                    console.log('i am here');
                    emitValue = moment(d, this.control.format);
                    console.log('emitValue', emitValue);
                }
                this.currentValue = emitValue;
                console.log(`about to emit and update value to ${emitValue}`);
                return this.updateValue(emitValue);
            },

            /**
             * onSelect get date
             * @param {Date} startDate
             * @param {Date|null} endDate
             */
            getValue1(startDate, endDate="") {
                //console.log(`in datepicker method getValue: ${startDate}, ${endDate}`);
                if (startDate == null) {
                    return this.updateValue(null)
                }

                // Single-mode will have a single emit
                if (this.control.singleMode) {
                    let emitValue = startDate

                    // Parse to format before emit??
                    if (this.control.returnType === DATE_PICKER_RETURN_TYPES.format.val) {
                        //emitValue = dayjs(startDate).format(this.control.format)
                        emitValue = moment(startDate).format(this.control.format)
                    }

                    // emit to parent
                    this.updateValue(emitValue)
                    this.currentValue = emitValue
                    return
                }

                // date-range will have {startDate: ... , endDate: ...}
                let emitValue = {
                    startDate,
                    endDate,
                }

                // Parse to format before emit??
                if (this.control.returnType === DATE_PICKER_RETURN_TYPES.format.val) {
                    /*
                    emitValue.startDate = dayjs(startDate).format(this.control.format)
                    emitValue.endDate = dayjs(endDate).format(this.control.format)
                    */
                    emitValue.startDate = moment(startDate).format(this.control.format)
                    emitValue.endDate = moment(endDate).format(this.control.format)
                }

                // emit to parent
                this.updateValue(emitValue)
                this.currentValue = emitValue
            },
        },
        mounted() {            
            /*
            this.datepicker = new Litepicker({
                element: document.getElementById(this.control.uniqueId),                
                ...this.control,
                
                onRender: () => {                
                    console.log(`on render`);    
                    if (this.control.defaultValue) {
                        this.setValue(this.control.defaultValue);
                    }
                },
                
                onSelect: (d) => { 
                    console.log('hi');
                }  
            });            
            */
        },

        beforeDestroy() {
            //this.datepicker.destroy()
        },

        computed: {
            startDateFieldName() {
                return (this.control.name || this.control.uniqueId) + '[startDate]'
            },
            endDateFieldName() {
                return (this.control.name || this.control.uniqueId) + '[endDate]'
            },

            hasStartDate() {
                return this.value && this.value.startDate
            },

            hasEndDate() {
                return this.value && this.value.endDate
            },

            /**
             * Determines if we're in builder mode (preview) vs renderer mode (patient-facing form)
             */
            isBuilderMode() {
                return this.$parent && this.$parent.readOnly === undefined;
            },

            /**
             * Whether the date picker should be readonly (prefillTodayDate enabled and in renderer mode)
             */
            isPrefillReadonly() {
                return this.control.prefillTodayDate && !this.isBuilderMode;
            },

            /**
             * CSS class for prefill styling
             */
            prefillClass() {
                if (!this.control.prefillTodayDate) {
                    return '';
                }
                return this.isBuilderMode ? 'prefill-today-preview' : 'prefill-today-readonly';
            }
        }
    }
</script>

<style scoped>
/* Preview styling for Pre-fill Today's Date in FormBuilder */
.prefill-today-preview {
    background-color: #eff6ff !important;
    border-color: #93c5fd !important;
    color: #1e40af !important;
    font-style: italic;
}

/* Readonly styling for Pre-filled Today's Date in FormRenderer (patient-facing) */
.prefill-today-readonly {
    background-color: #f5f5f5 !important;
    font-weight: bold !important;
    color: #333 !important;
    cursor: not-allowed;
    pointer-events: none;
    user-select: none;
}
</style>
